// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","fixed":"Navbar_fixed__qv2q0","navList":"Navbar_navList__6cV1C","active":"Navbar_active__l7FQP"};